import { createFileRoute } from "@tanstack/react-router";

import { LoginScreen, loginSearchSchema } from "@/features/auth";

const LoginPage = () => {
  const { next, ref } = Route.useSearch();
  return <LoginScreen next={next} referralCode={ref} />;
};

// Страница без входа (`staticData.isPublic`): оболочка не требует сессии.
export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  staticData: { isPublic: true },
  component: LoginPage,
});
